import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import SmoothScroll from "./components/SmoothScroll";
import SplashScreen from "./components/SplashScreen";
import Header from "./components/Header";
import Hero from "./components/Hero";
import PressStrip from "./components/PressStrip";
import About from "./components/About";
import Certificates from "./components/Certificates";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Packages from "./components/Packages";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";

import { AuthProvider } from "./contexts/AuthContext";
import AdminLayout from "./components/admin/AdminLayout";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import LoginPage from "./components/admin/LoginPage";
import Dashboard from "./components/admin/Dashboard";
import ImageLibrary from "./components/admin/ImageLibrary";
import PortfolioEditor from "./components/admin/PortfolioEditor";
import ServicesEditor from "./components/admin/ServicesEditor";
import PricelistEditor from "./components/admin/PricelistEditor";
import PackagesEditor from "./components/admin/PackagesEditor";
import PressEditor from "./components/admin/PressEditor";
import FaqsEditor from "./components/admin/FaqsEditor";
import TestimonialsEditor from "./components/admin/TestimonialsEditor";
import CertificatesEditor from "./components/admin/CertificatesEditor";
import SettingsPage from "./components/admin/SettingsPage";
import BrandEditor from "./components/admin/BrandEditor";

const Landing = () => {
    const [ready, setReady] = useState(false);
    return (
        <>
            <SplashScreen onFinish={() => setReady(true)} />
            <SmoothScroll>
                <div
                    className={`App relative transition-opacity duration-700 ${
                        ready ? "opacity-100" : "opacity-0"
                    }`}
                >
                    <Header />
                    <main>
                        <Hero />
                        <PressStrip />
                        <About />
                        <Certificates />
                        <Services />
                        <Portfolio />
                        <Packages />
                        <Contact />
                    </main>
                    <Footer />
                    <WhatsAppButton />
                    <Toaster
                        position="bottom-center"
                        theme="dark"
                        toastOptions={{
                            style: {
                                background: "#15120f",
                                border: "1px solid rgba(212,175,55,0.3)",
                                color: "#fdfbf7",
                                fontFamily: "Outfit, sans-serif",
                            },
                        }}
                    />
                </div>
            </SmoothScroll>
        </>
    );
};

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/admin/login" element={<LoginPage />} />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute>
                                <AdminLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Dashboard />} />
                        <Route path="brand" element={<BrandEditor />} />
                        <Route path="images" element={<ImageLibrary />} />
                        <Route path="portfolio" element={<PortfolioEditor />} />
                        <Route path="services" element={<ServicesEditor />} />
                        <Route path="pricelist" element={<PricelistEditor />} />
                        <Route path="packages" element={<PackagesEditor />} />
                        <Route path="press" element={<PressEditor />} />
                        <Route path="faqs" element={<FaqsEditor />} />
                        <Route path="testimonials" element={<TestimonialsEditor />} />
                        <Route path="certificates" element={<CertificatesEditor />} />
                        <Route path="settings" element={<SettingsPage />} />
                      </Route>
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-of-service" element={<TermsOfService />} />
                    <Route path="*" element={<Landing />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
